import '/assets/styles/main.css';

import header from './components/header.js';
import menu from './components/menu.js';
import slider from './components/slider.js';
import modal from './components/modal.js';
import jobForm from './components/jobForm.js';
import contactForm from './components/contactForm.js';
import manageThemeColor from './components/manageThemeColor.js';
import footerReveal from './components/footerReveal.js';
import didomi from './components/didomi.js';
import video from './components/video.js';
import connecterAnimation from './components/connecterAnimation.js';
import accompagnerAnimation from './components/accompagnerAnimation.js';
import project from './components/project.js';
import stickerAnim from './components/sticker-animation.js';


document.addEventListener('DOMContentLoaded', async () => {
  header();
  menu();
  slider();
  project();
  stickerAnim();
  modal();
  jobForm();
  contactForm();
  footerReveal();
  manageThemeColor();
  video();
  connecterAnimation();
  accompagnerAnimation();
});

didomi();

